<template>
  <div>
    <div v-if="forConasi">
      <nav class="navbar navbar-inverse fixed-top topnavbar" style="background-color: #FF6D6D;">
        <div class="container-fluid topnavbar">
          <div class="navbar-header topnavbar header-top-account">
            <a v-if="hotline" :href="`tel:${hotline}`"><i class="fas fa-phone"></i></a>
            <span v-if="hotline">|</span>
            <a href="mailto:"><i class="fas fa-envelope"></i></a>
            <span>|</span>
            <a href="https://www.facebook.com/conasi365.vn/" target="_blank"><i class="fab fa-facebook-f"></i></a>
          </div>
          <div class="navbar-header navbar-right header-top-account">
            <div v-if="!isLogged()">
              <a href="#" @click="onChangeLocale">{{ $i18n.locale === "en" ? "VI" : "EN" }}</a>
              <span>|</span>
              <router-link :to="'/login'">
              <!-- <a href="#" @click="goScreenLogin"><i class="fas fa-user"></i> {{ $t("common.login") }}</a> -->
                <a href="#"><i class="fas fa-user"></i> {{ $t("common.login") }}</a>
              </router-link>
              <span>|</span>
              <router-link :to="'/register'">
                <!-- <a href="#" @click="goScreenRegister"><i class="fas fa-unlock-alt"></i> {{ $t("common.register") }}</a> -->
                <a href="#"><i class="fas fa-unlock-alt"></i> {{ $t("common.register") }}</a>
              </router-link>
            </div>
            <div v-else>
              <a href="#" @click="onChangeLocale">{{ $i18n.locale === "en" ? "VI" : "EN" }}</a>
              <span>|</span>
              <router-link :to="'/profile'">
                <!-- <a href="#" @click="onViewProfile"><i class="fas fa-user"></i> {{ userProfile.fullName }}</a> -->
                <a href="#"><i class="fas fa-user"></i> {{ userProfile.fullName }}</a>
              </router-link>
              <span>|</span>
              <a href="#" @click="onLogout($event)"><i class="fas fa-sign-out-alt"></i> {{ $t("common.logout") }}</a>
            </div>
          </div>
        </div>
      </nav>
      <nav class="navbar fixed-top navbar-expand-md navbar-light bg-menu" style="margin-top: 31px">
        <a class="navbar-brand logo-responsive">
          <a v-if="forConasi" href="https://conasi365.vn" target="_blank"><img src="../assets/conasi365_logo.png" height="28px" /></a>
          <img v-else src="../assets/e_voucher_logo.svg" height="28px" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapseMenu"
          aria-controls="navbarCollapseMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="menuClosed = !menuClosed"
          style="color: #ff6d6d; border: none;"
        >
          <!-- <span class="navbar-toggler-icon"></span> -->
          <div v-show="menuClosed">
            <i class="fas fa-bars"></i>
          </div>
          <div v-show="!menuClosed">
            <i class="fas fa-times"></i>
          </div>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapseMenu">
          <ul class="navbar-nav mr-auto" style="margin: auto;">
            <div v-for="(link, index) in links_conasi" :key="link + index" :class="['hover-item-menu mx-2', currentRouter == link.to ? 'active-item-menu' : '']">
              <router-link
                v-if="!link.subLinks"
                class="nav-item active text-center"
                :to="link.to"
              >
                <a class="nav-link bar-item-text text-uppercase">{{ $t(link.text) }}</a>
              </router-link>
              <li v-else class="nav-item active dropdown">
                <a
                  class="nav-link dropdown-toggle primary-color text-uppercase"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ $t(link.text) }}
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <div
                    v-for="(subLink, index) in link.subLinks"
                    :key="subLink + index"
                  >
                    <router-link class="dropdown-item" :to="subLink.to">{{
                      $t(subLink.text)
                    }}</router-link>
                  </div>
                </div>
              </li>
            </div>
          </ul>
          <div v-if="hotline" class="my-2 my-lg-0" style="display: flex;">
            <a class="nav-link bar-item-text text-uppercase" :href="`tel:${hotline}`"><i class="fas fa-headphones"></i> {{ hotline }}</a>
          </div>
        </div>
      </nav>
    </div>
    <div v-else>
      <nav class="navbar fixed-top navbar-expand-sm navbar-light bg-toolbar">
        <div class="container">
          <div class="navbar-brand"><img src="../assets/e_voucher_logo.svg" height="28px" /></div>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapseMenu"
            aria-controls="navbarCollapseMenu"
            aria-expanded="false"
            @click="menuClosed = !menuClosed"
            style="color: #28A745; border: none;"
          >
            <div v-show="menuClosed">
              <i class="fas fa-bars"></i>
            </div>
            <div v-show="!menuClosed">
              <i class="fas fa-times"></i>
            </div>
          </button>
          <div class="collapse navbar-collapse" id="navbarCollapseMenu">
            <div class="w-100 flex-md-column">
              <div class="container-fluid topnavbar">
                <div class="navbar-header topnavbar header-account" />
                <div class="navbar-header navbar-right header-account">
                  <div v-if="!isLogged()">
                    <span style="cursor: pointer" @click="onChangeLocale">{{ $i18n.locale === "en" ? "VI" : "EN" }}</span>
                    <span>|</span>
                    <router-link :to="'/register'">
                      <a href="#"><i class="fas fa-unlock-alt"></i> {{ $t("common.register") }}</a>
                    </router-link>
                    <span>|</span>
                    <router-link :to="'/login'">
                      <a href="#"><i class="fas fa-user"></i> {{ $t("common.login") }}</a>
                    </router-link>
                  </div>
                  <div v-else>
                    <span style="cursor: pointer" @click="onChangeLocale">{{ $i18n.locale === "en" ? "VI" : "EN" }}</span>
                    <span>|</span>
                    <span style="cursor: pointer" @click="onLogout($event)" class="button-logout"><i class="fas fa-sign-out-alt"></i> {{ $t("common.logout") }}</span>
                      <span>|</span>
                    <span class="dropdown menu-item">
                      <span data-toggle="dropdown">
                        <i class="fas fa-user"></i> {{ userProfile.fullName }} <i class="fas fa-sort-down ml-1 mb-1" />
                      </span>
                      <div class="dropdown-menu action-form">
                        <menuSignOut @logOutSuccess="userLogOut"/>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="navbar-collapse">
                <ul class="navbar-nav ml-auto mb-2 mb-md-0">
                  <div v-for="(link, index) in links_avatar" :key="link + index" :class="['hover-item-menu mx-2', currentRouter == link.to ? 'active-item-menu' : '']">
                    <router-link
                      v-if="!link.subLinks"
                      class="nav-item active text-center"
                      :to="link.to"
                    >
                      <a class="nav-link bar-item-text text-uppercase">{{ $t(link.text) }}</a>
                    </router-link>
                    <li v-else class="nav-item active dropdown text-center">
                      <a
                        class="nav-link dropdown-toggle bar-item-text text-uppercase"
                        id="navbarDropdown"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ $t(link.text) }}
                      </a>
                      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                        <div
                          v-for="(subLink, index) in link.subLinks"
                          :key="subLink + index"
                        >
                          <router-link class="dropdown-item" :to="subLink.to">{{
                            $t(subLink.text)
                          }}</router-link>
                        </div>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import * as $ from 'jquery'
import { isCookieEnabled, getCookie } from "tiny-cookie";
import { mapGetters, mapActions } from "vuex";
import dateUtils from "Utils/dateUtils";
import functionUtils from "Utils/functionUtils";
import stringUtils from "Utils/stringUtils";
import menuSignOut from "@/components/menuSignOut";
import { FOR_CONASI_TARGET } from 'Utils/constants'

export default {
  data: () => ({
    menuClosed: true,
    isLogged: false,
    links_conasi: [
      {
        to: '/look-up-voucher',
        text: 'menu.lookupVoucher'
      },
      {
        to: '/my-voucher',
        text: 'menu.myVoucher'
      },
      {
        to: '/guide-look-up-voucher',
        text: 'menu.guide',
      },
    ],
    links_avatar: [
      {
        to: '/my-voucher',
        text: 'menu.myVoucher'
      },
      {
        to: '/look-up-voucher',
        text: 'menu.lookupVoucher'
      },
      {
        to: '/guide-look-up-voucher',
        text: 'menu.guide',
        subLinks: [
          {
            to: '/guide-lookup',
            text: 'help.lookupTitle',
          },
          {
            to: '/guide-registration',
            text: 'help.registrationTitle',
          },
          {
            to: '/guide-usage',
            text: 'help.usageTitle',
          },
        ],
      },
    ],
    eVoucherIssueQueueList: [],
    eVoucherIssueQueueCount: 0,
    responsive: false,
    currentRouter: '',
    userProfile: {
      id: null,
      username: null,
      fullName: "",
      email: null,
      gender: null,
      birtdate: null,
      phone: null,
      urlAvatar: null
    },
    objectSettingKey: stringUtils.ObjectSettingKey,
    hotline: null,
    forConasi: FOR_CONASI_TARGET
  }),
  components: {
    menuSignOut
  },
  created() {
    this.isLogged = () => loadSessionFromCookie();
    const loadSessionFromCookie = () => {
      const token = isCookieEnabled() ? getCookie("token") : null;
      if (token) {
        return true;
      } else {
        return false;
      }
    };
    this.getIssueEVoucherQueueList();
    let filter = {
      params: {
        key: this.objectSettingKey.COMPANY_HOTLINE
      }
    }
    this.GET_OBJECT_SETTING(filter)
  },
  watch: {
    '$route' (to) {
      this.currentRouter = to.path
      this.menuClosed = $('#navbarCollapseMenu').collapse('hide')
    },

    GET_CURRENT_ACCOUNT() {
      this.userProfile.id = this.GET_CURRENT_ACCOUNT.id;
      this.userProfile.username = this.GET_CURRENT_ACCOUNT.username;
      if (
        !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.lastname) &&
        !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.firstname)
      ) {
        this.userProfile.fullName =
          this.GET_CURRENT_ACCOUNT.lastname +
          " " +
          this.GET_CURRENT_ACCOUNT.firstname;
      }
      this.userProfile.email = this.GET_CURRENT_ACCOUNT.email;
      this.userProfile.urlAvatar = this.GET_CURRENT_ACCOUNT.url_avatar
    },
    OBJECT_SETTING_DATA() {
      let data = this.OBJECT_SETTING_DATA
      let hotlineSettingData = data.filter(element => {
        return element.key === this.objectSettingKey.COMPANY_HOTLINE
      })
      if (hotlineSettingData.length > 0) {
        this.hotline = hotlineSettingData[0].value
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_CURRENT_ACCOUNT",
      "ISSUE_E_VOUCHER_QUEUE_DATA",
      "OBJECT_SETTING_DATA"
    ]),
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    /**
     * Get language
     */
    getLanguage: function () {
      if (this.$i18n.locale == 'vi') {
        return 'common.vietnamese'
      } else {
        return 'common.english'
      }
    },
    /**
     * Change locale
     */
    onChangeLocale(){
      let locale = this.$i18n.locale === 'en' ? 'vi' : 'en'
      this.CHANGE_LOCALE(locale);
    },
    /** 
    * Responsive inverted
    */
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    /**
     * View detail e voucher issue queue
     */
    viewDetailEVoucherIssueQueue: function(event) {
      event.preventDefault();
      this.$router.push({
        path: "e-voucher-issue-queue-list",
      });
    },
    /**
     * Get issue e voucher queue list
     */
    getIssueEVoucherQueueList: function() {
      let filter = {
        params: {
          page: null,
        },
      };
      this.GET_ISSUE_E_VOUCHER_QUEUE(filter).then(
        function(res) {
          let data = res.data;
          let length = data.length;
          this.eVoucherIssueQueueCount = length;
          this.countCallGetIssueEvoucherQueue = [];
          for (let i = 0; i < length; i++) {
            let obj = {
              stt: i + 1,
              dateExpired: dateUtils.formatDate(
                data[i].date_expired,
                dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
                dateUtils.STATIC_FORMAT_DATE
              ),
              dateCreated: dateUtils.formatDate(
                data[i].date_created,
                dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
                dateUtils.STATIC_FORMAT_DATE
              ),
              name: data[i].voucher.name,
              serial: data[i].voucher.serial,
            };
            this.eVoucherIssueQueueList.push(obj);
          }
        }.bind(this)
      );
    },
    /**
     * View profile
     */
    onViewProfile: function() {
      this.$router.push({
        name: "Profile",
      });
    },
    /**
     * Logout
     */
    onLogout: function(event) {
      event.preventDefault();
      let token = isCookieEnabled() ? getCookie("token") : null;
      this.LOGOUT(token)
        .then(
          function() {
            this.$router.push({
              name: "LookUpVoucher",
            });
          }.bind(this)
        )
        .catch(
          function() {
            this.$router.push({
              name: "LookUpVoucher",
            });
          }.bind(this)
        );
    },
    userLogOut: function () {
    },
    /**
     * Login
     */
    goScreenLogin: function() {
      this.$router.push({
        name: "login",
      });
    },
    goScreenRegister: function() {
      this.$router.push({
        name: "register",
      });
    },
    // Register Supplier
    onClickRegisterSupplier: function(){
      let aminUlr = process.env.VUE_APP_ADMIN_URL;
      let url = aminUlr + "/register-supplier";
      let urlData = functionUtils.removeDoubleSlashesFromUrl(url);
      window.open(urlData, "_blank");
    },
    onClickSearchVoucher: function () {
      this.$router.push({
        path: "/my-vouchers",
      });
    },
    validateStringIsNull: function (value) {
      return functionUtils.validateStringIsNull(value)
    },
    ...mapActions([
      "SET_USER_DATA",
      "LOGOUT",
      "GET_ISSUE_E_VOUCHER_QUEUE",
      "CHANGE_LOCALE",
      "GET_OBJECT_SETTING"
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.bg-toolbar {
  background-image: url('../assets/background-footer.png') !important;
  background-size: 100% 100% !important;
}
.item-notification:hover {
  background-color: #e5e5e5;
}
.logo-responsive {
  width: 10%;
}
// .hover-item-menu:hover {
//   background-color: #43a047;
//   border-radius: 3px;
// }
// .active-item-menu {
//   background-color: #43a047;
//   border-radius: 3px;
// }
.hover-item-menu a:hover {
  text-decoration: none;
}
.bg-fullname {
  padding: 8px 8px 8px 8px;
  border-radius: 3px;
}
.bg-fullname:hover {
  background-color: #43a047;
}
.menu-icon {
  width: 35px;
  height: 5px;
  background-color: black;
  margin: 6px 0;
}

.background-handle-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1;
}

.box-profile {
  width: 20vw;
  float: right;
  background-color: #fff;
  text-align: left;
  border: 1px solid #707070;
  position: absolute;
  z-index: 1;
  transform: translate(78.8vw);
  padding: 15px;

  .content {
    padding: 0 40px;
    color: $primary;

    p {
      margin-bottom: 5px;
    }
  }

  .box-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;

    button {
      color: $primary;
      border: none;
      background-color: transparent;
      font-size: 20px;
      font-weight: 600;

       &:focus {
        box-shadow: 0 0 0 0.2rem rgba(227,137,137,.5);
        outline: none;
      }

      &:hover {
        color: #a7634e;
      }
    }
  }
}

.button-logout {
  color: #a7634e !important;
}
.button-logout:hover {
  color: #ff6d6d !important;
}

.icon-size{
  font-size: 22px;
}
/* 
  ##Device = Desktops
  ##Screen = 1281px to higher resolution desktops
*/

@media (min-width: 1281px) {
  .logo-responsive {
    width: 10%;
  }
}

/* 
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/

@media (min-width: 1025px) and (max-width: 1280px) {
  .logo-responsive {
    width: 15%;
  }

  .box-profile {
    width: 30vw;
    transform: translate(70vw);
  }
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  .logo-responsive {
    width: 15%;
  }

  .box-profile {
    width: 40vw;
    transform: translate(60vw);
  }
}

/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .logo-responsive {
    width: 15%;
  }
}

/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/

@media (min-width: 481px) and (max-width: 767px) {
  .logo-responsive {
    width: 25%;
  }

  .box-profile {
    width: 100%;
    transform: none;
  }
}

/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  .logo-responsive {
    width: 25%;
  }
  .box-profile {
    width: 100%;
    transform: none;
  }
}
//
.form-control {
  box-shadow: none;
  font-weight: normal;
  font-size: 13px;
}
.navbar {
  background: #fff;
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 1px solid #dfe3e8;
  border-radius: 0;
}
.nav-link img {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin: -5px 0;
  float: left;
  margin-right: 10px;
}
.navbar .form-inline {
  display: inline-block;
}
.navbar a {
  color: #888;
}
.navbar .sign-up-btn {
  min-width: 110px;
  max-height: 36px;
}
.navbar .dropdown-menu {
  color: #999;
  font-weight: normal;
  border-radius: 1px;
  border-color: #e5e5e5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.navbar .navbar-form {
  border: none;
}
.navbar .action-form {
  width: 250px;
  padding: 20px;
  left: auto;
  right: 0;
  font-size: 14px;
}
.navbar .action-form a {
  color: #33cabb;
  padding: 0 !important;
  font-size: 14px;
}
.navbar .action-form .hint-text {
  text-align: center;
  margin-bottom: 15px;
  font-size: 13px;
}
.navbar .btn-primary,
.navbar .btn-primary:active {
  color: #fff;
  background: #33cabb !important;
  border: none;
}
.navbar .btn-primary:hover,
.navbar .btn-primary:focus {
  color: #fff;
  background: #31bfb1 !important;
}
.navbar .social-btn .btn,
.navbar .social-btn .btn:hover {
  color: #fff;
  margin: 0;
  padding: 0 !important;
  font-size: 13px;
  border: none;
  transition: all 0.4s;
  text-align: center;
  line-height: 34px;
  width: 47%;
  text-decoration: none;
}
.navbar .social-btn .facebook-btn {
  background: #507cc0;
}
.navbar .social-btn .facebook-btn:hover {
  background: #4676bd;
}
.navbar .social-btn .twitter-btn {
  background: #64ccf1;
}
.navbar .social-btn .twitter-btn:hover {
  background: #4ec7ef;
}
.navbar .social-btn .btn i {
  margin-right: 5px;
  // font-size: 16px;
  position: relative;
  top: 2px;
}
.or-seperator {
  margin-top: 32px;
  text-align: center;
  border-top: 1px solid #e0e0e0;
}
.or-seperator b {
  color: #666;
  padding: 0 8px;
  width: 30px;
  height: 30px;
  font-size: 13px;
  text-align: center;
  line-height: 26px;
  background: #fff;
  display: inline-block;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  position: relative;
  top: -15px;
  z-index: 1;
}
.navbar .action-buttons .dropdown-toggle::after {
  display: none;
}
.form-check-label input {
  position: relative;
  top: 1px;
}
.topnavbar {
  padding: 1px 0px 1px 0px;
  margin: 0;
}
.topnavbaritem {
    font-size: 10px;
    color: #a7634e;
    padding: 3px 1px 3px 1px;
    margin-top: 0px 3px 0px 3px;
}
.svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -.125em;
}
.svg-inline--fa.fa-w-16 {
    width: 1em;
}
.header-account a,
.header-account span,
.header-top-account a,
.header-top-account span {
  display: inline-block;
  font-size: 13px;
  line-height: 1.6;
  color: whitesmoke;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  text-decoration: none;
  margin-left: 7px;
  margin-right: 7px;
}
.header-account a:hover,
.header-top-account a:hover {
  color: #0b4f6c;
}
.header-account a,
.header-account span {
  color : #062d3d;
}
@media (min-width: 1200px) {
  .form-inline .input-group {
    width: 300px;
    margin-left: 30px;
  }
}
@media (max-width: 768px) {
  .navbar .dropdown-menu.action-form {
    width: 100%;
    padding: 10px 15px;
    border: none;
  }
  .navbar .form-inline {
    display: block;
  }
  .navbar .input-group {
    width: 100%;
  }
}
// 
.bar-item-text {
  font-weight: 700;
  font-size: 14pt;
  font-style: normal;
  color: #FF6D6D !important;
  font-family: "Roboto" !important;
}
.divider-text:after {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 1px solid #ddd;
  top: 55%;
  left: 0;
  z-index: 1;
}
.divider-text {
  position: relative;
  text-align: center;
  margin-bottom: 15px;
}
.mouse-pointer:hover{
  color: $second-500
}
.dropdown-menu.action-form {
  min-width: 280px;
}
.menu-item:hover {
  cursor: pointer;
}
</style>
